import React, { useCallback, useEffect, useMemo, useState } from "react";
import crueslect from "../../assets/images/cru-select/cruselect-1.webp";
import crueslect_2 from "../../assets/images/cru-select/cruselect-2.webp";
import crueslect_3 from "../../assets/images/cru-select/cruselect-3.webp";
import crueslect_4 from "../../assets/images/cru-select/cruselect-4.webp";
import crueslect_5 from "../../assets/images/cru-select/cruselect-5.webp";
import crueslect_6 from "../../assets/images/cru-select/cruselect-6.webp";
import crueslect_7 from "../../assets/images/cru-select/cruselect-7.webp";
import crueslect_8 from "../../assets/images/cru-select/cruselect-8.webp";
import crueslect_9 from "../../assets/images/cru-select/cruselect-9.webp";
import crueslect_10 from "../../assets/images/cru-select/cruselect-10.webp";
import crueslect_11 from "../../assets/images/cru-select/cruselect-11.webp";
import crueslect_12 from "../../assets/images/cru-select/cruselect-12.webp";
import crueslect_13 from "../../assets/images/cru-select/cruselect-13.webp";
import crueslect_14 from "../../assets/images/cru-select/cruselect-14.webp";
import crueslect_15 from "../../assets/images/cru-select/cruselect-15.webp";
import crueslect_16 from "../../assets/images/cru-select/cruselect-16.webp";
import crueslect_17 from "../../assets/images/cru-select/cruselect-17.webp";
import crueslect_18 from "../../assets/images/cru-select/cruselect-18.webp";
import crueslect_19 from "../../assets/images/cru-select/cruselect-19.webp";
import crueslect_20 from "../../assets/images/cru-select/cruselect-20.webp";
import SingleProduct from "../Items/SingleProduct";
import { pageWiseProductListData } from "../../services/frontService/ProductService";
import { toast } from "react-toastify";
import Pagination from "../form/Pagination";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { loginModalOpen } from "../../redux/slice/loginSlice";
import Modal from "../elements/Modal/Modal";
import QuickViewModal from "./QuickViewModal";
import { getPageData } from "../../services/frontService/PageService";
import ProductLoader from "../loader/ProductLoader";
const CruSelectProduct = ({ slug, addToCart = () => {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState({ data: {}, open: false });
  const isLogin = useSelector((state) => state?.auth?.isLogin);
  const [limit, setLimit] = useState({ name: "60 Items", value: 60 });
  const [status, setStatus] = useState("all");
  const [offset, setOffset] = useState(0);

  const [pagination, setPagination] = useState({
    hasNextPage: false,
    hasPrevPage: false,
  });
  const [list, setList] = useState({
    loading: true,
    data: [],
    pageCount: 0,
    totalItem: 0,
  });
  const [count, setCount] = useState(0);
  const [items] = useState([...Array(100).keys()]); // Example items array
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 60;

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 500, behavior: "smooth" });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
  const [homeData, setHomeData] = useState({});

  const loadPageData = useCallback(() => {
    getPageData({
      slug: "cru-select",
    }).then((res) => {
      if (res?.status === 200) {
        setHomeData(res?.data);
      }
    });
  }, []);

  useEffect(() => {
    loadPageData();
  }, [loadPageData]);

  const actions = useMemo(() => {
    return [
      // {
      //   _id: 1,
      //   icon: "fa-light fa-heart",
      //   isLink: false,
      //   isWishlist: true,
      //   isSolid: isSolid,
      //   click: (data) => {
      //     if (isLogin) {
      //       addWishList(data);
      //     } else {
      //       dispatch(loginModalOpen({ isOpen: true }));
      //     }
      //   },
      // },
      {
        _id: 2,
        icon: "fa-light fa-bag-shopping",
        isLink: false,
        click: (data) => {
          if (isLogin) {
            addToCart(data);
          } else {
            dispatch(loginModalOpen({ isOpen: true }));
          }
        },
      },
      {
        _id: 3,
        icon: "fa-light fa-arrow-right",
        isLink: false,
        click: (data) => {
          navigate(`/productdetails/${data?.alias}`);
        },
      },
      {
        _id: 4,
        icon: "fa-light fa-eye",
        isLink: false,
        click: (data) => setIsOpen({ open: true, data: data }),
      },
    ];
  }, [isLogin]);

  //   loading the member list >>>>>>>>>
  const loadList = useCallback(() => {
    setList((pre) => ({
      ...pre,
      data: [],
      loading: true,
    }));
    pageWiseProductListData({
      perPage: limit?.value,
      page: currentPage,
      cat_slug: slug,
    }).then((res) => {
      if (res && res?.docs?.success) {
        setList({
          loading: false,
          data: res?.docs?.data,
          pageCount: res?.docs?.metadata?.totalPages,
          totalItem: res?.docs?.metadata?.totalDocs,
        });
        setCount(res?.docs?.metadata?.totalDocs);
        setPagination({
          hasNextPage: res?.docs?.metadata?.hasNextPage,
          hasPrevPage: res?.docs?.metadata?.hasPrevPage,
        });
      } else {
        setList((pre) => ({ ...pre, data: [], loading: true }));
        toast.error(res?.message);
      }
    });
  }, [limit, status, currentPage, isLogin]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  const featuredProductData = {
    subheading: "Great Designs At The Best Price",
    heading: homeData?.name || "CRU SELECT",
    description:
      homeData?.description ||
      "HJL Designs is now carrying RJS designed labels for all RJS products. Like our non-branded labels, they are printed on high quality, easily removable nylon at a size of 9.5 cm x 7cm without leaving any residue behind.",
    subdata: list && list?.data?.length > 0 ? list?.data : [],
  };
  const loaders = Array(20).fill(null);
  return (
    <>
      <section className="sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto md:px-0 px-5">
        <div className="text-center md:pt-20 pt-10 md:px-32 px-0">
          <h2 className="great-design xl:text-6xl md:text-5xl text-2xl font-bold pt-2 pb-4 drop-shadow-md uppercase">
            <span className="relative inline-block !leading-none before:content-[''] before:absolute before:top-2/4 before:-translate-y-1/2 md:before:-left-36 before:-left-20 md:before:w-32 before:w-16 before:border-t-2 before:border-black after:content-[''] after:absolute after:top-2/4 after:-translate-y-1/2 md:after:-right-36 after:-right-20 md:after:w-32 after:w-16 after:border-t-2 after:border-black">
              {featuredProductData?.heading}
            </span>
          </h2>
        </div>

        {list?.loading ? (
          <>
            <div className="grid xl:grid-cols-4 md:grid-cols-3 grid-cols-2 xl:gap-8 md:gap-8 gap-5 md:pt-36 pt-28">
              {loaders?.map((_, index) => (
                <ProductLoader key={index} />
              ))}
            </div>
          </>
        ) : (
          featuredProductData?.subdata?.length > 0 && (
            <>
              <div className="grid md:grid-cols-4 grid-cols-2 md:gap-8 gap-8 md:pt-20 pt-8">
                {featuredProductData.subdata.map((item, index) => (
                  <SingleProduct
                    key={index}
                    data={item}
                    lable={crueslect_17}
                    actions={actions}
                  />
                ))}
              </div>
              <Pagination
                totalItems={count}
                itemsPerPage={limit?.value}
                onPageChange={handlePageChange}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </>
          )
        )}
        <Modal
          size="xl4"
          modalTitle=""
          open={isOpen?.open}
          // onClose={() => setIsOpen({ open: false })}
        >
          <QuickViewModal
            onClose={() => setIsOpen({ open: false })}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
          />
        </Modal>
      </section>
    </>
  );
};

export default CruSelectProduct;
